import { Instance, types } from 'mobx-state-tree'
import '../../ieConfig/MobxConfig'
import { ConvenienceFee } from './ConvenienceFee'

const Bank = types.model('Bank', {
  id: types.identifier,
  name: types.optional(types.string, ''),
  accountNumber: types.optional(types.string, ''),
  logo: types.optional(types.string, ''),
  isPopular: types.optional(types.boolean, false),
  rank: types.optional(types.number, 0),
  convenienceFee: types.array(ConvenienceFee),
  paymentType: types.optional(types.string, 'Bank'),
  isCnb: types.optional(types.boolean, false),
})

export type BankType = Instance<typeof Bank>
export { Bank }
